<template>
  <div>
    <v-container
      fluid
      :class="almost_mobile ? 'pt-16 stycard' : 'pt-16 px-10 stycard'"
      style="min-height: 100vh"
    >
      <h3 class="pb-2 pt-3 pl-2" style="color: #00a99d; font-size: 25px">
        เวชระเบียน
      </h3>
      <div style="margin-top: 30px"></div>
      <v-row class="ml-1">
        <v-col cols="12" sm="12" md="4" lg="4" xl="4" class="card-search mb-5">
          <v-text-field
            v-model="search"
            class="card-search"
            label="ค้นหา"
            dense
            solo
            hide-details
            append-icon="mdi-magnify"
            clearable
          ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="6" sm="12" md="4" lg="4" xl="4" class="mb-5" style="text-align:end">
          <v-btn color="#00a99d" dark @click="addPatient()"
            ><v-icon class="mr-2">mdi-plus-circle</v-icon
            >ลงทะเบียนผู้ป่วย</v-btn
          >
        </v-col>
      </v-row>
      <v-data-table
        class="elevation-1 table-viewdoc"
        :headers="headers"
        :items="patientList"
        hide-default-footer
        @click:row="patientOpen"
      >
        <template v-slot:item.no="{ index }">
          <span class="font-16">{{ ((page*limit)-limit) + index + 1 }}.</span>
        </template>
        <template v-slot:item.name="{ item }">
          <span class="font-16"
            >{{ item.account_title_th }} {{ item.first_name_th }}
            {{ item.last_name_th }}
          </span>
        </template>
        <template v-slot:`item.gender`="{ item }">
          <span class="font-16">{{ displayItem(item, "gender") }}</span>
        </template>
        <template v-slot:item.old="{ item }">
          <span class="font-16">{{ displayItem(item, "old") }}</span>
        </template>
        <template v-slot:item.phone="{ item }">
          <span class="font-16">{{ displayItem(item, "phone") }}</span>
        </template>
        <template v-slot:item.company="{ item }">
          <span class="font-16">{{ item.company }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end py-2">
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click="patientOpen(item)"
                  >
                    <v-icon color="#00a99d"
                      >mdi-account-box-outline</v-icon
                    >
                  </v-btn>
                </div>
              </template>
              <span>ข้อมูลผู้ป่วย</span>
              </v-tooltip> -->
            <v-tooltip bottom v-if="!item.healthcheck_status">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click="healthOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-file-document</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>ผลตรวจสุขภาพประจำปี</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="dianoticOpen(item)"
                  >
                    <v-icon color="#00a99d"
                      >mdi-clipboard-text-clock-outline</v-icon
                    >
                  </v-btn>
                </div>
              </template>
              <span>ประวัติการรักษา</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="emrCall(item)"
                  >
                    <v-icon color="#00a99d">mdi-phone-outgoing</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>EMR Call</span>
            </v-tooltip>
            <v-tooltip v-if="biz_id !== '1349242890488778'" bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="findCIDOpen(item)"
                  >
                    <v-icon color="#00a99d">mdi-qrcode</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>QR code</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    class="mx-1"
                    color="#00a99d"
                    icon
                    @click.stop="dashboardEditNurseDialog(item)"
                  >
                    <v-icon color="#00a99d">mdi-square-edit-outline</v-icon>
                  </v-btn>
                </div>
              </template>
              <span>แก้ไขข้อมูลผู้ป่วย</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <Pagination :totals="total" :isPage="page" @page="changePage" />

      <!-- <HistoryCalling ref="HistoryCalling" /> -->
      <HistoryDianotic ref="HistoryDianotic" />
      <FindByCid ref="FindByCid" />

      <!-- เพิ่มรายชื่อผู้ป่วย -->
      <RegisterPatient
        ref="registerPatient"
        @addPatient="getPatitentList"
      />

      <!--ข้อมูลผู้ป่วย / เเก้ไขข้อมูลผู้ป่วย -->
      <DashboardEditNurseDialog
        ref="dashboardEditNurseDialog"
        @close="getPatitentList"
      />
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations, mapGetters } from "vuex";
import functioncryto from "@/services/encrypt.js";
// import HistoryCalling from "@/components/dialog/HistoryCalling.vue";
import HistoryDianotic from "@/components/dialog/HistoryDianotic.vue";
// import HeaderUser from "@/components/dialog/HeaderUser.vue";
import FindByCid from "@/components/dialog/FindByCid.vue";
import { Pagination } from "@/components/pagination";
import RegisterPatient from "@/components/dialog/RegisterPatient.vue";
import DashboardEditNurseDialog from "@/components/DashboardEditNurseDialog.vue";

export default {
  components: {
    // HistoryCalling,
    HistoryDianotic,
    // HeaderUser,
    FindByCid,
    Pagination,
    RegisterPatient,
    DashboardEditNurseDialog,
    
  },
  data: () => ({
    search: "",
    editedIndex: -1,
    headers: [
      {
        text: "ลำดับ",
        value: "no",
        sortable: false,
        align: "center",
        width: "10%",
      },
      {
        text: "ชื่อผู้รับบริการ",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "เพศ",
        align: "left",
        sortable: false,
        value: "gender",
      },
      {
        text: "อายุ",
        align: "left",
        sortable: false,
        value: "old",
      },
      {
        text: "ข้อมูลติดต่อ",
        align: "left",
        sortable: false,
        value: "phone",
      },
      {
        text: "สถานประกอบการ",
        align: "left",
        sortable: false,
        value: "company",
      },
      {
        text: "ACTION",
        value: "actions",
        sortable: false,
        align: "center",
        width: "15%",
      },
    ],
    patientList: [],
    total: 0,
    page: 1,
    limit: 10,
    object_id: "",
    edit: false,
    biz_id: ""
  }),
  async created() {
    await this.getPatitentList();
    this.biz_id = sessionStorage.biz_id;
  },
  computed: {
    ...mapGetters(["bizId"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    search(val) {
      if (val == "" || val == null) {
        this.getPatitentList();
      } else {
        this.searchData();
      }
    },
  },
  methods: {
    ...mapMutations(["setDetailConference", "setDetailPhysicalExam"]),
    dashboardEditNurseDialog(item) {
      this.$refs.dashboardEditNurseDialog.openDialog(item, false);
    },
    addPatient() {
      this.$refs.registerPatient.openDialog()
    },
    openConference(item) {
      this.setDetailConference(item);
      this.$router.push({ name: "ConferenceDetail" });
    },
    async getPatitentList() {
      const params = new URLSearchParams();
      params.append("page", this.page || 1);
      params.append("limit", this.limit || 10);
      params.append("biz_id", sessionStorage.biz_id);
      await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients/all?${params}`)
        .then((res) => {
          if (res.data) {
            if (res.data.data[0]) {
              const { data: searchData, metadata } = res.data.data[0];
              

              if (metadata.length == 0) {
                this.total = 0;
                this.patientList = [];
              } else {
                const { total } = metadata[0];
                this.total = total;
                this.patientList = searchData;
              }
            }
          }
        });
    },
    async searchData() {
      const params = new URLSearchParams();
      params.append("page", this.page || 1);
      params.append("limit",  this.limit);
      params.append("biz_id", sessionStorage.biz_id);
      params.append("search", this.search);
      await this.axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/v1/patients/search_record?${params}`)
        .then((res) => {
          if (res.data) {
            let searchPatient = res.data.data[0].data;
            searchPatient.forEach((element) => {
              element.fullname = `${
                element.account_title_th ? element.account_title_th : ""
              }${element.first_name_th ? element.first_name_th : ""} ${
                element.last_name_th ? element.last_name_th : ""
              }`;
            });
            this.patientList = Object.assign([], searchPatient);
            // console.log("searchData", this.patientList);
          }
        });
    },
    async emrCall(item) {
      const { one_id, account_title_th, first_name_th, last_name_th } = item;
      const params = {
        send_by: {
          one_id: sessionStorage.account_id,
          role: sessionStorage.role_name,
        },
        biz_id: sessionStorage.biz_id,
        receiver_oneid: one_id,
        sender_oneid: sessionStorage.account_id,
        topic_name: "Emr-call",
        mode: "oneid",
        secret_key: "80135d71877e4afa31ad52043fd46b09ba26eb68",
        record: true,
        redirect_url: "https://uat-amctelemedicine.one.th/management/thank-you",
        ref1: `BIZID_${sessionStorage.biz_id}`,
        ref2:"teleconsult_Emr",
        ref3:`${first_name_th} ${last_name_th}`
      };
      try {
        const { data: { result, data } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/create-room-emr`,
          params
        );
        if (result == "success") {
          this.setDetailConference({
            ...data,
            patient_name: `${account_title_th} ${first_name_th} ${last_name_th}`,
          });
          this.$router.push({ name: "ConferenceDetail" });
        }
      } catch (error) {
        console.error();
      }
    },
    healthOpen(item) {
      const { one_id, first_name_th, last_name_th } = item;
      const payload = {
        one_id: one_id,
        year: moment().format("YYYY"),
        bizId: sessionStorage.biz_id,
        checkDate: moment().format("YYYY-MM-DD"),
        queue: "",
        general: {
          general: {
            weight: "",
            height: "",
            bmi: "",
            comment: "",
            congenitalDisease: "",
            allergicHistory: "",
            smokingHistory: "",
            historyOfDrinking: "",
            bp: "",
            pulse: "",
            lastMenstrualPeriod: "",
            summaryBpPuls: "",
            summaryPhysical: "",
            chestXray: "",
            ekg: "",
            visionTest: "",
          },
          occupationVisionTest: {
            visionTests_R: "",
            visionTests_L: "",
            visionTests_3D: "",
            visionTestsSeparate: "",
            visionTestsEyeMuscles: "",
            visionTestsField: "",
          },
          audioGraphy: {
            audiometry_R: ["", "", "", "", "", "", ""],
            audiometry_L: ["", "", "", "", "", "", ""],
            audiometry: "",
          },
          lungFunctionTest: {
            fev1: "",
            fvc: "",
            fev1_fvc: "",
            resutLungTest: "",
            lungFunctionTest: "",
          },
        },
        treatmentEtc: {
          other: [
            {
              checklist: "",
              results: "",
              normal: "",
              summary: "ปกติ",
            },
            {
              checklist: "",
              results: "",
              normal: "",
              summary: "ปกติ",
            },
          ],
          performance: {
            armAndHand: {
              results: "",
              summary: "ปกติ",
            },
            backAndlegs: {
              results: "",
              summary: "ปกติ",
            },
          },
          stoolExam: "",
        },
        bloodCount: {
          completeBloodCount: {
            hb: "",
            hct: "",
            rbc: "",
            wbc: "",
            neutrophil: "",
            lymphocyte: "",
            monocyte: "",
            eosinophi: "",
            basophil: "",
            platelet: "",
            mcv: "",
            mch: "",
            mchc: "",
            rbcMorphology: "",
            summaryBloodCount: "",
          },
        },
        urineResults: {
          urinalysis: {
            colors: "",
            appearance: "",
          },
          urineStrip: {
            specificGravity: {
              result: "",
            },
            ph: {
              result: "",
            },
            glucose: {
              result: "",
            },
            protein: {
              result: "",
            },
            blood: {
              result: "",
            },
          },
          urineMicroscopy: {
            wbc: {
              result: "",
            },
            rbc: {
              result: "",
            },
            epithelialCell: {
              result: "",
            },
            bacteria: {
              result: "",
            },
          },
        },
        labResult: {
          liverFunction: {
            totalProtein: {
              result: "",
              summary: "ปกติ",
            },
            albumin: {
              result: "",
              summary: "ปกติ",
            },
            glubulin: {
              result: "",
              summary: "ปกติ",
            },
            totalBilirubin: {
              result: "",
              summary: "ปกติ",
            },
            directBilirubin: {
              result: "",
              summary: "ปกติ",
            },
            sgot: {
              result: "",
              summary: "ปกติ",
            },
            sgpt: {
              result: "",
              summary: "ปกติ",
            },
            alkPhosphatase: {
              result: "",
              summary: "ปกติ",
            },
          },
          kidneyFunction: {
            bun: {
              result: "",
              summary: "ปกติ",
            },
            creatinine: {
              result: "",
              summary: "ปกติ",
            },
          },
          uricAcidFunction: {
            uricAcid: {
              result: "",
              summary: "ปกติ",
            },
          },
          bloodGroupDetection: {
            bloodGroup: {
              result: "",
              summary: "ปกติ",
            },
          },
          hepatitisB: {
            HBsAg: {
              result: "",
              summary: "ไม่ปกติ",
            },
            antiHBs: {
              result: "",
              summary: "ปกติ",
            },
          },
          urine: {
            amphetamine: {
              result: "",
              summary: "ปกติ",
            },
          },
        },
        laboratory: {
          bloodSugarLevel: {
            fbs: {
              result: "",
              summary: "ปกติ",
            },
          },
          bloodLipidLevel: {
            cholesterol: {
              result: "",
              summary: "ปกติ",
            },
            triglyceride: {
              result: "",
              summary: "ปกติ",
            },
            HDLCholesterol: {
              result: "",
              summary: "ปกติ",
            },
            LDLCholesterol: {
              result: "",
              summary: "ปกติ",
            },
          },
        },
        summary: [
          {
            general_status: "",
          },
          {
            blood_status: "",
          },
          {
            urine_status: "",
          },
          {
            x_ray_status: "",
          },
          {
            vision_status: "",
          },
          {
            pressure_status: "",
          },
          {
            b_virus_status: "",
          },
          {
            hdl_status: "",
          },
          {
            ldl_status: "",
          },
        ],
        file_id: "",
        full_name_th: `${first_name_th} ${last_name_th}`,
        full_name_eng: null,
        search_name: `${first_name_th} ${last_name_th}`,
        date: moment().format("YYYY"),
        fullname: "",
      };
      console.log(payload);
      // const {} = item;
      // const data =

      // this.setDetailPhysicalExam(payload);
      // this.$router.push({ name: "PhysicalExam" });

      // this.$router.push({ name: "PhysicalExam" });
    },
    dianoticOpen(item) {
      this.$refs.HistoryDianotic.open(item);
    },
    patientOpen( $event , item_data) {
      var item = item_data.item
      this.$refs.dashboardEditNurseDialog.openDialog(item)
    },
    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "";
    },
    findCIDOpen(item) {
      this.$refs.FindByCid.open(item);
      // this.$router.push({ name: "PhysicalExam" });
    },
    displayItem(item, type) {
      const { account_title_th, birth_date, mobile } = item;
      switch (type) {
        case "gender":
          if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
          if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
            return "หญิง";
          break;
        case "old":
          if (birth_date) {
            const y = Math.floor(
              moment.duration(moment().diff(birth_date)).asYears()
            );
            return y;
          }
          break;
        case "phone":
          if (mobile) {
            return mobile;
          }
          break;
      }
    },
    changePage(e) {
      this.page = e;
      this.getPatitentList();
    },
  },
};
</script>
<style>
.stycard {
  /* bg */
  position: absolute;
  /* white */
  background: #ffffff;
  border-radius: 80px 0px 0px 0px;
}
.card-search {
  background: #ceefed;
  border-radius: 20px 5px;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}

</style>

